import styled from 'styled-components';

export const StyledAnimatedIconWrapper = styled.div<{ open: boolean }>`
	float: right;
	transform: rotate(0deg);
	overflow: hidden;
	transition: all 0.3s ease-out;
	transform: ${props => (props.open ? `rotate(180deg)` : '')};
`;
